import { useRewardPoolAccessPoliciesQuery } from '@shared/hooks/query/rewardPools';

import { mapAccessPoliciesToRequirements } from './mapAccessPoliciesToRequirements';

export const useRequirements = (poolId: number) => {
  const query = useRewardPoolAccessPoliciesQuery(poolId);

  const { data: policies = [] } = query;

  const requirements = mapAccessPoliciesToRequirements(policies);

  return {
    requirements,
    hasRequirements: Boolean(requirements.length),
    query,
  };
};
